(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    

 

  $(document).ready(function(){
      $(".sku-barcode-wrap, .yv-pricebox-outer").wrapAll("<div class='sku-price-wrap'></div>");
      $(".yv-product-quantity, .product_button").wrapAll("<div class='quantity-button-wrap'></div>");
  });

     $('.productOption').change(function(){
      var var_bar =  $(this).attr('meta-value');
      console.log(var_bar,'var_bar');
      $('.yv-product-barcode').text('UPC# ' + var_bar);
    });
       


  } catch(e) { console.error(e); }
})();
})();
